import getApi from '../../api/apisauceConfig'
import { Contact } from '../../model/Contact'

export const getContact = (id: string) => getApi().get<Contact>(`/contacts/${id}`)
